// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AnimatedBadge__container-d84541 {
  height: 20px;
  width: 20px;
  overflow: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/AnimatedBadge/AnimatedBadge.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AACF","sourcesContent":[".container {\n  height: 20px;\n  width: 20px;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AnimatedBadge__container-d84541`
};
module.exports = ___CSS_LOADER_EXPORT___;
